import React from 'react';
import { Skeleton } from 'antd';
import { isStatVizType } from './reportingStatCard';

/**
 * Placeholder while chart data loads — keeps grid height stable during collapse expand.
 */
const TREEMAP_TILES = [
    { col: '1 / 3', row: '1 / 3' },
    { col: '3 / 5', row: '1 / 2' },
    { col: '5 / 7', row: '1 / 3' },
    { col: '3 / 4', row: '2 / 3' },
    { col: '4 / 6', row: '2 / 3' },
    { col: '1 / 4', row: '3 / 4' },
    { col: '4 / 7', row: '3 / 4' },
];

export default function ReportingChartSkeleton({ vizSpec, mode = 'chart' }) {
    const isStat = isStatVizType(vizSpec);
    const isTreemap = vizSpec?.type === 'treemap';

    if (mode === 'table') {
        return (
            <div style={{ padding: '12px 16px', height: '100%', minHeight: 120, boxSizing: 'border-box' }}>
                <Skeleton active title={false} paragraph={{ rows: 6, width: ['100%', '92%', '88%', '95%', '80%', '70%'] }} />
            </div>
        );
    }

    if (isStat) {
        return (
            <div
                style={{
                    padding: 16,
                    height: '100%',
                    minHeight: 100,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxSizing: 'border-box',
                }}
            >
                <Skeleton.Input active size="large" style={{ width: 120, minWidth: 80, marginBottom: 16 }} />
                <Skeleton active title={false} paragraph={{ rows: 1, width: ['50%'] }} />
            </div>
        );
    }

    if (isTreemap) {
        return (
            <div style={{ padding: 10, height: '100%', minHeight: 120, boxSizing: 'border-box' }}>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(6, 1fr)',
                        gridTemplateRows: 'repeat(3, 1fr)',
                        gap: 4,
                        height: '100%',
                        minHeight: 100,
                    }}
                >
                    {TREEMAP_TILES.map((tile, i) => (
                        <Skeleton.Button
                            key={i}
                            active
                            block
                            style={{
                                gridColumn: tile.col,
                                gridRow: tile.row,
                                width: '100%',
                                height: '100%',
                                minHeight: 28,
                            }}
                        />
                    ))}
                </div>
            </div>
        );
    }

    const barHeights = [0.42, 0.68, 0.5, 0.82, 0.58, 0.74, 0.46, 0.62];

    return (
        <div style={{ padding: '12px 16px 16px', height: '100%', minHeight: 120, boxSizing: 'border-box' }}>
            <Skeleton active title={{ width: '32%' }} paragraph={false} style={{ marginBottom: 14 }} />
            <div
                style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    gap: 6,
                    height: 'calc(100% - 36px)',
                    minHeight: 88,
                    paddingTop: 4,
                }}
            >
                {barHeights.map((ratio, i) => (
                    <div key={i} style={{ flex: 1, display: 'flex', alignItems: 'flex-end' }}>
                        <Skeleton.Button
                            active
                            block
                            style={{
                                height: Math.max(28, Math.round(88 * ratio)),
                                width: '100%',
                            }}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
